import script from "./ClientDetailList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ClientDetailList.vue?vue&type=script&setup=true&lang=ts"

import "./ClientDetailList.vue?vue&type=style&index=0&id=2734f424&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2734f424"]])

export default __exports__